export default "__VITE_ASSET__ezDZN6xDnSNL7vcEPPpLtA__"